import { render, staticRenderFns } from "./Roulette.vue?vue&type=template&id=b73c05f4&scoped=true"
var script = {}
import style0 from "./Roulette.vue?vue&type=style&index=0&id=b73c05f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73c05f4",
  null
  
)

export default component.exports